export default "__VITE_ASSET__DOhyaIYt__"